// simple abstraction to get data
import axios from 'axios';
// import { DATA_SOURCE_URL } from "./constants.js";
import S3 from 'aws-sdk/clients/s3';

async function getFile(params) {
    // This is kinda a vulnerability, but the potential damage is so low
    const encodedKey = 'QUtJQVZPREJHWUpZNjdINDVHV0k=';
    const accessKeyId = atob(encodedKey);
    const encodedSecretKey = 'WkJ2VlJmWDB2WjViNURDUGd3dEE2TVlYRlJQNnprWmlWWWwyYlJwZw==';
    const secretAccessKey = atob(encodedSecretKey);
    const s3 = new S3({
      accessKeyId,
      secretAccessKey,
      s3ForcePathStyle: true,
      signatureVersion: "v4",
      connectTimeout: 0,
      httpOptions: { timeout: 0 },
      region: 'us-east-2',
    });
    const url = s3.getSignedUrl("getObject", params);
    let schema = await axios({
      method: 'GET',
      url,
    });
    return typeof schema.data === 'string' ? JSON.parse(schema.data) : schema.data;
}

// future server get data function
async function getDataServer(dataName, accessToken) {
  // axios get data
  if (dataName && accessToken){
      const params = {
        Bucket: "sna-vue-1312026",
        Key: dataName,
      }

    // Example usage
    return getFile(params);
  }
}

// change export according to where you want the data from
export { getDataServer as getData }
